import { Navigate } from 'react-router-dom';

export default function SingleUseTokensPage() {
    return <Navigate to="/user-management-tokens" replace />;
}
